document.addEventListener('DOMContentLoaded', function(event) {
  // Open all Markdown-Links from external URL in new Tab
  function externalLinks() {
    var anchors = document.querySelectorAll('a');
    for (var i = 0; i < anchors.length; i++) {
      if (anchors[i].hostname !== window.location.hostname) {
        anchors[i].setAttribute('target', '_blank');
      }
    }
  }
  externalLinks();
});